export default __webpack_public_path__ + "static/IBMPlexSans-Thin-Cyrillic-92334d49ea4e1d1ca8a1c7cd989b38e6.woff";